import React from 'react'

import BaseAssemblyFormBlock from './BaseAssemblyFormBlock'

const HomeEquityFormBlock = () => {
  return <BaseAssemblyFormBlock formId='4967227' height='600' />
}

export default React.memo(HomeEquityFormBlock)
